<template>
  <div class="my_container">
    <div class="base_info">
      <div class="base_info_top">
        <div class="left">
          <img
            v-if="accountData.avatarUrl"
            :src="accountData.avatarUrl"
            alt=""
          />
          <img v-else src="@/assets/icon／用户.png" alt="" />
        </div>
        <div class="center">
          <div class="name">
            {{ userInfo.username }}
          </div>
          <div class="with_time">
            {{ baseData.systemTitle }}已陪伴你{{ withTime }}天啦~
          </div>
        </div>
        <div class="rig" @click="goBaseSetting">
          <img src="@/assets/my11.png" alt="" />
        </div>
      </div>
      <div class="base_info_bottom">
        <div class="bottom_item left">
          <div class="item_title">
            <span class="title_text">账户余额</span>

            <!-- <img
              v-if="showBalance"
              src="@/assets/icon_show.png"
              alt=""
              class="eye"
            />
            <img v-else src="@/assets/icon_show.png" alt="" class="eye" /> -->
          </div>
          <div class="item_info">
            <div>
              <span class="unit">￥</span>
              <span class="price">{{ accountData.balance }}</span>
            </div>

            <div class="text" @click="openPage('/rechrage')">充值</div>
            <div class="text" @click="openPage('/balance')">明细</div>
          </div>
        </div>

        <div class="bottom_item right">
          <div class="item_title">
            <span class="title_text">可提现余额</span>
            <!-- <img
              v-if="showBalanceWithdrawabl"
              src="@/assets/icon_show.png"
              alt=""
              class="eye"
            />
            <img v-else src="@/assets/icon_noshow.png" alt="" class="eye" /> -->
          </div>
          <div class="item_info">
            <div>
              <span class="unit">￥</span>
              <span class="price">{{ accountData.balanceWithdrawabl }}</span>
            </div>
            <div class="text" @click="openPage('/withdraw')">提现</div>
          </div>
        </div>
      </div>
    </div>
    <div class="order_nav">
      <div class="title">我的订单</div>

      <div class="nav_list">
        <div class="nav_item" @click="goOrderTab(1)">
          <img src="@/assets/my10.png" alt="" />
          <div class="text">待支付</div>
        </div>
        <div class="nav_item" @click="goOrderTab(2)">
          <img src="@/assets/my09.png" alt="" />
          <div class="text">打单中</div>
        </div>
        <div class="nav_item" @click="goOrderTab(3)">
          <img src="@/assets/my08.png" alt="" />
          <div class="text">已出单</div>
        </div>
        <div class="nav_item" @click="goOrderTab(4)">
          <img src="@/assets/my07.png" alt="" />
          <div class="text">取消/异常</div>
        </div>
      </div>
    </div>
    <div class="other_serve">
      <div class="title">其他服务</div>
      <div class="serve_list">
        <div class="serve_item" @click="openPage('/invite')">
          <img src="@/assets/my06.png" alt="" />
          <div class="text">邀请好友</div>
        </div>
        <div class="serve_item" @click="openPage('/extensions')">
          <img src="@/assets/my07.png" alt="" />
          <div class="text">邀请奖励</div>
        </div>
        <div class="serve_item" @click="openPage('/storeBind')">
          <img src="@/assets/my04.png" alt="" />
          <div class="text">店铺绑定</div>
        </div>
        <div class="serve_item" @click="openPage('/safeSetting')">
          <img src="@/assets/my03.png" alt="" />
          <div class="text">安全中心</div>
        </div>
        <div class="serve_item" @click="openConcat">
          <img src="@/assets/my02.png" alt="" />
          <div class="text">在线客服</div>
        </div>
        <div class="serve_item" @click="gotopc">
          <img src="@/assets/my13.png" alt="" />
          <div class="text">访问网页</div>
        </div>
        <div class="serve_item" @click="logout">
          <img src="@/assets/my12.png" alt="" />
          <div class="text">退出登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { sipUser, accountGet } from '@/api';
export default {
  mounted() {
    this.getUserInfo();
    this.getAccount();
  },
  data() {
    return {
      userInfo: {},
      baseData: baseData,
      withTime: '',
      accountData: {}
      // showBalance: false,
      // showBalanceWithdrawabl: false
    };
  },
  methods: {
    getUserInfo() {
      sipUser().then((res) => {
        if (res.success) {
          this.userInfo = res.data;
          let time = res.data.createTime;
          const timeNow = Date.parse(new Date());
          this.withTime = Math.ceil((timeNow - time) / (1000 * 60 * 60 * 24));
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    getAccount() {
      accountGet().then((res) => {
        this.accountData = res.data;
      });
    },
    // handleChangeShow() {
    //   this.showBalance = !this.showBalance;
    // },
    goOrderTab(index) {
      this.$router.push({ path: '/order', query: { index } });
    },
    goBaseSetting() {
      this.$router.push('/baseSetting');
    },
    openPage(path) {
      this.$router.push(path);
    },
    //   ------
    ...mapActions(['Logout']),
    //退出登录
    logout() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '真的要注销登录吗 ?'
        })
        .then(() => {
          return this.Logout({})
            .then(() => {
              // 退出登录跳转回首页
              window.location.href = '/';
            })
            .catch((err) => {
              that.$toast.fail({
                title: '错误',
                description: err.message
              });
            });
        });
    },
    gotopc() {
      localStorage.setItem('agents', 'pc');
      //访问pc首页
      window.location.href = window.location.origin + '/index';
    },
    openConcat() {
      window.open(
        'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97817c5390744c9abd4ae0e0344549e2a29e6fdc2fdf2b2137a1eaebae5c0f1ad81b0ab6a09db04a4b9520996e25ff7c'
      );
    }
  }
};
</script>
<style lang="less" scoped>
.my_container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding: 3.2vw;
  .base_info {
    background: #ffffff;
    border-radius: 2.133vw;
    margin-bottom: 3.2vw;
    .base_info_top {
      display: flex;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding: 5.333vw 3.2vw;
      .left {
        border-radius: 50%;
        img {
          width: 10.667vw;
          height: 10.667vw;
          margin-right: 3.2vw;
          border-radius: 50%;
        }
      }
      .center {
        flex: 1;
        .name {
          font-size: 4.533vw;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 2.133vw;
        }
        .with_time {
          font-size: 3.467vw;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .rig {
        img {
          width: 5.333vw;
          height: 5.067vw;
        }
      }
    }
    .base_info_bottom {
      padding: 4.267vw;
      display: flex;
      .bottom_item {
        flex: 1;
        .item_title {
          font-size: 3.733vw;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 3.2vw;
          display: flex;
          align-items: center;
          .title_text {
            margin-right: 1.067vw;
          }
          .eye {
            width: 3.2vw;
            height: 3.2vw;
          }
        }
        .item_info {
          display: flex;
          align-items: center;
          color: #f93244;

          .unit {
            font-size: 3.2vw;
            font-weight: 600;
          }
          .price {
            font-size: 4.533vw;
            margin-right: 3.2vw;
            font-family: Avenir-Heavy;
            line-height: 4.933vw;
            font-weight: 600;
          }
          .text {
            font-size: 3.467vw;
            color: rgba(0, 0, 0, 0.45);
            margin-right: 2.133vw;
            margin-top: 0.533vw;
          }
        }
      }
    }
  }
  .order_nav {
    background: #ffffff;
    border-radius: 2.133vw;
    margin-bottom: 3.2vw;
    .nav_list {
      display: flex;
      .nav_item {
        padding: 4.267vw 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 6.4vw;
          height: 6.4vw;
          margin-bottom: 3.2vw;
        }
        .text {
          font-size: 3.467vw;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
  .other_serve {
    background: #ffffff;
    border-radius: 2.133vw;
    .serve_list {
      display: flex;
      flex-wrap: wrap;
      .serve_item {
        padding: 4.267vw 0;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 6.4vw;
          height: 6.4vw;
          margin-bottom: 3.2vw;
        }
        .text {
          font-size: 3.467vw;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
  .title {
    font-size: 4.533vw;
    color: rgba(0, 0, 0, 0.85);
    padding: 3.2vw;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
